// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Products_ListImagesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /so/products/list_images/{so_product_id}
 *
 * Returns all gallery image rows for a product, ordered by
 * `so_product_image_sort_order ASC, so_product_image_id ASC`. The
 * controller hydrates each row from the model output and appends Azure
 * Blob URLs via the `azure_image` helper.
 *
 * The array MUST be typed as `Products_ListImageRow[]`, not
 * `Products_UploadImageResponse[]` — the QA rule
 * `no-response-array-of-response` forbids reusing a response shape as a
 * list item, which is why `Products_ListImageRow` exists as a separate
 * RowContract.
 */
import type { Products_ListImageRow } from './Products_ListImageRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Products_ListImagesResponseDados = Products_ListImageRow[];

export type Products_ListImagesResponse = ApiResponse<Products_ListImagesResponseDados>;

registerResponseContract('Products_ListImagesResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      so_product_image_id:            { type: 'number',  required: true },
      so_product_id:                  { type: 'number',  required: true },
      so_product_image_filename:      { type: 'string',  required: true },
      so_product_image_url:           { type: 'string',  required: true },
      so_product_image_thumbnail_url: { type: 'string',  required: true },
      so_product_image_alt_text:      { type: 'string',  required: false },
      so_product_image_sort_order:    { type: 'number',  required: true },
      so_product_image_is_primary:    { type: 'boolean', required: true },
    },
  },
})
